import React from 'react';
import classnames from 'classnames';

import IconGuide from 'style/icons/icon-guide.svg';
import { CLICK } from 'externals/_tracking/types/eventTypes.constants';
import { openNewTab } from 'helpers/domHelper';
import { Link } from '../navigation/Link/Link';

const CollectionRedirect = ({
  className = '',
  clickType = 'Download Collections Guide',
  eventHandler,
  linkText = 'Get a free 6-steps guide',
  text = 'to help you deal with your collections.',
  moduleName,
  url = 'https://smart.link/rbfe5mo56ankf',
}) => {
  const onClickOpenApp = () => {
    eventHandler(CLICK, {
      'Click Type': clickType,
      'Module Name': moduleName,
    });
    openNewTab(url);
  };

  return (
    <div
      className={classnames(
        'flex-container',
        'align-items-center',
        'padtb6',
        'padlr8',
        'bgYellow050',
        'column-gap-4',
        className,
      )}
    >
      <img
        className="width52px m-width82px"
        src={IconGuide}
        alt="checklist board"
      />
      <span className="text-16 fontLatoBold m-text-14 m-padtb8">
        <Link to="#" onClickCallback={onClickOpenApp}>
          {linkText}
        </Link>{' '}
        {text}
      </span>
    </div>
  );
};

export default CollectionRedirect;
